module.exports = __webpack_public_path__ + "img/lineup31@2x.699d0383.png";